var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pro_enc_input_edit"
  }, [_c('Input', _vm._b({
    attrs: {
      "value": _vm.value,
      "element-id": _vm.rangeId
    },
    on: {
      "input": _vm.onInput
    }
  }, 'Input', _vm.$attrs, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };